export default __webpack_public_path__ + "static/media/whistle.d614f633.svg";